const scrollIntoViewWithOffset = (element, offset) =>
  window.scrollTo({
    behavior: 'smooth',
    top: element.getBoundingClientRect().top + window.scrollY - offset,
  })

export const scrollToAnchor = (hash, e) => {
  if (hash) {
    const id = hash.replace('#', '')
    const element = document.getElementById(id)
    if (element) {
      if (e) e.preventDefault()
      scrollIntoViewWithOffset(element, 70)
      element.id = ''
      window.location.hash = hash
      element.id = id
    }
  }
}
